module.exports = __webpack_public_path__ + "static/media/audience.4b60d0eb.svg";